export default __webpack_public_path__ + "static/media/banner1.7d31167a.png";